import React from 'react';


import * as SS from '../TripHotelDetails/TripsHotelDetails.styles';
import * as S from './ImportantInfo.styles';

const ImportantInfo = ({impInfo}) => {
  const {important_info = [], showImpInfo} = impInfo;
  if (!showImpInfo || !important_info.length) {
    return null;
  }

  return(
    <SS.TripHotelDetailMainWrap>
      <SS.TripHotelDetailHeaderWrap>
        <SS.TripHotelHeaderText>IMPORTANT INFORMATION</SS.TripHotelHeaderText>
      </SS.TripHotelDetailHeaderWrap>
      <SS.TripHotelInfoWrap>
        {important_info.map((item, i) => 
          <li key={`info${i}`}>{item}</li>
        )}
      </SS.TripHotelInfoWrap>
    </SS.TripHotelDetailMainWrap>
  );
}

export default ImportantInfo;